import { LOCALE, setLocale } from '../lib/i18n'

// 顶栏的语言切换。按钮上写的是「切过去之后的那门语言」，
// 并用那门语言自己写 —— 看不懂当前语言的人也认得出该点哪个。
export default function LanguageToggle({ className = '' }: { className?: string }) {
  const next = LOCALE === 'zh' ? 'en' : 'zh'
  return (
    <button
      type="button"
      onClick={() => void setLocale(next)}
      lang={next === 'en' ? 'en' : 'zh-CN'}
      title={next === 'en' ? 'Switch to English' : '切换到中文'}
      className={`inline-flex flex-none items-center whitespace-nowrap rounded-full border border-brand-line bg-brand-glass2 px-2.5 py-1 font-mono text-[11px] font-semibold text-brand-ink2 hover:bg-brand-glass hover:text-brand-ink focus:outline-none focus:ring-2 focus:ring-brand-clash ${className}`}
    >
      {next === 'en' ? 'EN' : '中文'}
    </button>
  )
}
